module.exports = __webpack_public_path__ + "img/full3-min.3ee3f2e0.png";